var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSdgIconDe10(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlSpace: "preserve",
    width: 566.93335,
    height: 566.93335,
    viewBox: "0 0 566.93335 566.93335",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,566.93333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4252,0 H 0.00390625 V 4252 H 4252 V 0",
    style: {
      fill: "#e20a85",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 411.816,3695.75 v -657.27 h 144.368 v 858.65 H 440.91 L 307.98,3741.34 V 3590.6 h 1.211 L 410.5,3695.75 h 1.316",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 800.598,3237.27 v 461.02 c 0,51.92 18.972,88.66 68.386,88.66 50.657,0 69.629,-36.74 69.629,-88.66 v -461.02 c 0,-51.95 -18.972,-88.59 -69.629,-88.59 -49.414,0 -68.386,36.64 -68.386,88.59 m 282.412,22.79 v 415.45 c 0,134.25 -67.1,231.73 -214.026,231.73 -145.601,0 -212.808,-97.48 -212.808,-231.73 v -415.45 c 0,-132.93 67.207,-231.73 212.808,-231.73 146.926,0 214.026,98.8 214.026,231.73",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2508.08,1431.3 h -791.79 c -4.75,0 -8.6,-4.32 -8.6,-9.61 v -237.96 c 0,-5.4 3.85,-9.66 8.6,-9.66 h 791.79 c 4.85,0 8.7,4.26 8.7,9.66 v 237.96 c 0,5.29 -3.85,9.61 -8.7,9.61",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2508.08,1937.63 h -791.79 c -4.75,0 -8.6,-4.32 -8.6,-9.61 v -237.96 c 0,-5.4 3.85,-9.66 8.6,-9.66 h 791.79 c 4.85,0 8.7,4.26 8.7,9.66 v 237.96 c 0,5.29 -3.85,9.61 -8.7,9.61",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2496.94,2297.34 -380.06,380.06 c -2.57,2.57 -6.72,2.57 -9.29,0 l -380.06,-380.06 c -4.14,-4.13 -1.21,-11.21 4.64,-11.21 h 760.13 c 5.85,0 8.78,7.08 4.64,11.21",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2853.72,1171.15 380.06,380.06 c 2.57,2.56 2.57,6.71 0,9.28 l -380.06,380.06 c -4.13,4.14 -11.21,1.21 -11.21,-4.64 v -760.12 c 0,-5.85 7.08,-8.78 11.21,-4.64",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1727.53,814.359 380.06,-380.058 c 2.57,-2.571 6.72,-2.571 9.29,0 l 380.06,380.058 c 4.14,4.129 1.21,11.211 -4.64,11.211 h -760.13 c -5.85,0 -8.78,-7.082 -4.64,-11.211",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1370.73,1940.55 990.676,1560.49 c -2.559,-2.57 -2.559,-6.72 0,-9.28 l 380.054,-380.06 c 4.14,-4.14 11.22,-1.21 11.22,4.64 v 760.12 c 0,5.85 -7.08,8.78 -11.22,4.64",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1506.47,3758.43 -33.92,-222.04 h -56.7 l -48.22,359.29 h 58.29 l 28.09,-227.87 h 0.52 l 30.21,227.87 h 49.29 l 33.38,-227.87 h 0.53 l 27.56,227.87 h 50.87 l -46.63,-359.29 h -57.24 l -35.51,222.04 h -0.52",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1669.72,3895.68 h 144.14 v -49.28 h -83.73 v -102.81 h 59.88 v -48.75 h -59.88 v -109.17 h 83.73 v -49.28 h -144.14 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1894.43,3762.14 v -225.75 h -50.87 v 359.29 h 59.35 l 65.18,-206.14 v 206.14 h 50.35 v -359.29 h -53 l -71.01,225.75",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2050.25,3895.68 h 60.42 v -359.29 h -60.42 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2234.15,3728.22 H 2320 v -191.83 h -43.46 v 39.21 c -7.94,-27.03 -24.91,-43.45 -57.76,-43.45 -51.93,0 -75.78,41.33 -75.78,96.98 v 173.82 c 0,56.17 27.02,96.97 90.62,96.97 66.77,0 86.38,-37.09 86.38,-90.08 v -31.8 h -55.12 v 36.57 c 0,22.25 -8.47,34.97 -30.2,34.97 -21.73,0 -31.27,-15.37 -31.27,-37.1 v -192.89 c 0,-21.73 9.01,-37.1 29.68,-37.1 19.61,0 29.68,11.13 29.68,34.45 v 63.59 h -28.62 v 47.69",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2351.81,3895.68 h 144.15 v -49.28 h -83.73 v -102.81 h 59.88 v -48.75 h -59.88 v -109.17 h 83.73 v -49.28 h -144.15 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2586.07,3846.4 v -111.81 h 20.13 c 20.67,0 29.68,10.59 29.68,29.67 v 53 c 0,19.6 -9.01,29.14 -29.68,29.14 z m 0,-145.2 v -164.81 h -60.42 v 359.29 h 87.97 c 60.94,0 83.2,-30.2 83.2,-80.55 v -46.1 c 0,-38.69 -13.78,-61.47 -48.22,-69.42 l 57.76,-163.22 h -63.59 l -56.7,164.81",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1551.52,3395.68 v -271.85 c 0,-55.65 -23.85,-91.68 -85.33,-91.68 -63.59,0 -90.08,36.03 -90.08,91.68 v 271.85 h 60.41 V 3118 c 0,-21.2 8.47,-35.51 29.67,-35.51 21.2,0 29.68,14.31 29.68,35.51 v 277.68 h 55.65",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1631.55,3262.14 v -225.75 h -50.86 v 359.29 h 59.35 l 65.18,-206.14 v 206.14 h 50.35 v -359.29 h -53 l -71.02,225.75",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1875.88,3228.22 h 85.85 v -191.83 h -43.46 v 39.21 c -7.95,-27.03 -24.91,-43.45 -57.76,-43.45 -51.93,0 -75.78,41.33 -75.78,96.98 v 173.82 c 0,56.17 27.02,96.97 90.61,96.97 66.78,0 86.39,-37.09 86.39,-90.08 v -31.8 h -55.12 v 36.57 c 0,22.25 -8.47,34.97 -30.2,34.97 -21.73,0 -31.27,-15.37 -31.27,-37.1 v -192.9 c 0,-21.72 9.01,-37.09 29.68,-37.09 19.61,0 29.67,11.13 29.67,34.45 v 63.59 h -28.61 v 47.69",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1990.89,3395.68 h 60.42 v -310.01 h 72.07 v -49.28 h -132.49 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2145.65,3395.68 h 144.15 v -49.28 h -83.73 v -102.81 h 59.88 v -48.75 h -59.88 v -109.17 h 83.73 v -49.28 h -144.15 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2316.84,3395.68 h 60.41 v -359.29 h -60.41 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2406.93,3129.13 v 173.82 c 0,56.17 26.5,96.97 90.09,96.97 66.77,0 85.32,-37.09 85.32,-90.08 v -42.4 h -55.11 v 47.17 c 0,22.25 -7.42,34.97 -29.15,34.97 -21.73,0 -30.73,-15.37 -30.73,-37.1 v -192.9 c 0,-21.72 9,-37.09 30.73,-37.09 21.73,0 29.15,13.78 29.15,34.98 v 66.24 h 55.11 v -62 c 0,-51.41 -21.2,-89.56 -85.32,-89.56 -63.59,0 -90.09,41.33 -90.09,96.98",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2728.62,3194.84 h -58.29 v -158.45 h -60.42 v 359.29 h 60.42 v -152.09 h 58.29 v 152.09 h 60.94 v -359.29 h -60.94 v 158.45",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2937.44,3194.84 h -58.29 v -158.45 h -60.42 v 359.29 h 60.42 v -152.09 h 58.29 v 152.09 h 60.94 v -359.29 h -60.94 v 158.45",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3027.55,3395.68 h 144.14 v -49.28 h -83.73 v -102.81 h 59.88 v -48.75 h -59.88 v -109.17 h 83.73 v -49.28 h -144.14 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3198.73,3395.68 h 60.42 v -359.29 h -60.42 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3281.95,3395.68 h 160.56 v -49.28 h -49.81 v -310.01 h -60.94 v 310.01 h -49.81 v 49.28",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3465.31,3395.68 h 144.15 v -49.28 h -83.73 v -102.81 h 59.89 v -48.75 h -59.89 v -109.17 h 83.73 v -49.28 h -144.15 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3687.37,3262.14 v -225.75 h -50.87 v 359.29 h 59.35 l 65.19,-206.14 v 206.14 h 50.34 v -359.29 h -53 l -71.01,225.75",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path70"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdgIconDe10);
export default __webpack_public_path__ + "static/media/SDG-icon-DE-10.e573d4a4801be29b474b66b29b6732e4.svg";
export { ForwardRef as ReactComponent };